import { ResourceName } from "@/types";
import { VendorsList } from "./VendorsList";
import { VendorsShow } from "./VendorsShow";
import { getResourceIcon } from "@/utils/icons";

const VendorIcon = getResourceIcon(ResourceName.VENDORS);

const resource = {
  list: VendorsList,
  show: VendorsShow,
  icon: VendorIcon,
  recordRepresentation: (record: any) => `${record.company_name}`,
};

export default resource;
